import { render, staticRenderFns } from "./AllUsersMessages.vue?vue&type=template&id=3bbfee6d&scoped=true&"
import script from "./AllUsersMessages.vue?vue&type=script&lang=js&"
export * from "./AllUsersMessages.vue?vue&type=script&lang=js&"
import style0 from "./AllUsersMessages.vue?vue&type=style&index=0&id=3bbfee6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbfee6d",
  null
  
)

export default component.exports